"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'TextBlock_1_0_0',
  paragraph: '',
  sectionHeading: '',
  mainHeading: '',
  theme: 'dark',
  textAlignment: 'left'
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;